const ONBOARDING_LEVEL = 6;
const PARENT_HOME_LEVEL = ONBOARDING_LEVEL + 15;
const ONBOARDING_CHILD_DEVICE_SAME_LEVEL = Math.max(
  ONBOARDING_LEVEL + 14,
  PARENT_HOME_LEVEL + 8,
);
const CHILD_HOME_LEVEL = ONBOARDING_CHILD_DEVICE_SAME_LEVEL + 4;
const LESSON_LEVEL = Math.max(CHILD_HOME_LEVEL, PARENT_HOME_LEVEL) + 1;

export const ROUTES = {
  ROOT: {
    id: 'ROOT',
    path: '/',
    level: 0,
  },
  RESET_PASSWORD: {
    id: 'RESET_PASSWORD',
    path: '/reset_password',
    level: 5,
  },
  AUTH_ACTION: {
    id: 'AUTH_ACTION',
    path: '/auth/action',
    level: 0,
  },
  INVITATIONS: {
    id: 'INVITATIONS',
    path: '/invitations',
    level: 0,
  },
  TERMS_AND_CONDITIONS: {
    id: 'TERMS_AND_CONDITIONS',
    path: '/terms-and-conditions',
    level: 1,
  },
  TERMS_AND_CONDITIONS_FR: {
    id: 'TERMS_AND_CONDITIONS_FR',
    path: '/terms-and-conditions/fr',
    level: 1,
  },
  TERMS_AND_CONDITIONS_EN: {
    id: 'TERMS_AND_CONDITIONS_EN',
    path: '/terms-and-conditions/en',
    level: 1,
  },
  CONFIDENTIALITE: {
    id: 'CONFIDENTIALITE',
    path: '/confidentialite',
    level: 1,
  },
  CONFIDENTIALITE_FR: {
    id: 'CONFIDENTIALITE_FR',
    path: '/confidentialite/fr',
    level: 1,
  },
  CONFIDENTIALITE_EN: {
    id: 'CONFIDENTIALITE_EN',
    path: '/confidentialite/en',
    level: 1,
  },
  FAMILY_CODE: {
    id: 'FAMILY_CODE',
    path: '/family-code',
    level: 3,
  },
  PARENT_UNLOCK: {
    id: 'PARENT_UNLOCK',
    path: '/parent/unlock/:token',
    level: 1,
  },
  SHARED_LESSON: {
    id: 'SHARED_LESSON',
    path: '/shared/lessons/:uuid',
    level: 0,
  },
  FUNNEL_RETURN: {
    id: 'FUNNEL_RETURN',
    path: '/funnel-return',
    level: 0,
  },
  SELECT_TYPE: {
    id: 'SELECT_TYPE',
    path: '/select-type',
    level: 1,
  },
  LOGIN: {
    id: 'LOGIN',
    path: '/login',
    level: 2,
  },
  LOGIN_EMAIL: {
    id: 'LOGIN_EMAIL',
    path: '/login/email',
    level: 3,
  },
  LOGIN_PASSWORD: {
    id: 'LOGIN_PASSWORD',
    path: '/login/password',
    level: 4,
  },
  LOGIN_CREATE_ACCOUNT: {
    id: 'LOGIN_CREATE_ACCOUNT',
    path: '/login/create-account',
    level: 4,
  },
  SELECT_FAMILY_USER: {
    id: 'SELECT_FAMILY_USER',
    path: '/select-family-user',
    level: 5,
  },
  ANONYMOUS_PARENT_FIRSTNAME: {
    id: 'ANONYMOUS_PARENT_FIRSTNAME',
    path: '/anonymous-parent-firstname',
    level: ONBOARDING_LEVEL + 2,
  },
  ANONYMOUS_CHILD_FIRSTNAME: {
    id: 'ANONYMOUS_CHILD_FIRSTNAME',
    path: '/anonymous-child-firstname',
    level: ONBOARDING_LEVEL + 1,
  },
  ONBOARDING: {
    id: 'ONBOARDING',
    path: '/onboarding',
    level: ONBOARDING_LEVEL,
  },
  ONBOARDING_PARENT_OBJECTIVE: {
    id: 'ONBOARDING_PARENT_OBJECTIVE',
    path: '/onboarding/parent/objective',
    level: ONBOARDING_LEVEL + 1,
  },
  ONBOARDING_PARENT_FIRSTNAME: {
    id: 'ONBOARDING_PARENT_FIRSTNAME',
    path: '/onboarding/parent/firstname',
    level: ONBOARDING_LEVEL + 2,
  },
  ONBOARDING_PARENT_CHILD_FIRSTNAME: {
    id: 'ONBOARDING_PARENT_CHILD_FIRSTNAME',
    path: '/onboarding/parent/child/firstname',
    level: ONBOARDING_LEVEL + 3,
  },
  ONBOARDING_PARENT_CHILD_THREE_MONTH_GOALS: {
    id: 'ONBOARDING_PARENT_CHILD_THREE_MONTH_GOALS',
    path: '/onboarding/parent/child/:childId/three-month-goals',
    level: ONBOARDING_LEVEL + 7.6,
  },
  ONBOARDING_PARENT_CHILD_NOTIFICATION: {
    id: 'ONBOARDING_PARENT_CHILD_NOTIFICATION',
    path: '/onboarding/parent/child/:childId/notification',
    level: ONBOARDING_LEVEL + 4,
  },
  ONBOARDING_PARENT_CHILD_GENDER: {
    id: 'ONBOARDING_PARENT_CHILD_GENDER',
    path: '/onboarding/parent/child/:childId/gender',
    level: ONBOARDING_LEVEL + 5,
  },
  ONBOARDING_PARENT_CHILD_SCHOOL_GROUP: {
    id: 'ONBOARDING_PARENT_CHILD_SCHOOL_GROUP',
    path: '/onboarding/parent/child/:childId/school_group',
    level: ONBOARDING_LEVEL + 6,
  },
  ONBOARDING_PARENT_CHILD_SCHOOL_LEVEL: {
    id: 'ONBOARDING_PARENT_CHILD_SCHOOL_LEVEL',
    path: '/onboarding/parent/child/:childId/school_level',
    level: ONBOARDING_LEVEL + 7,
  },
  ONBOARDING_PARENT_CHILD_SUBJECTS: {
    id: 'ONBOARDING_PARENT_CHILD_SUBJECTS',
    path: '/onboarding/parent/child/:childId/subjects',
    level: ONBOARDING_LEVEL + 7.5,
  },
  ONBOARDING_PARENT_CHILD_LABOR_EFFECT: {
    id: 'ONBOARDING_PARENT_CHILD_LABOR_EFFECT',
    path: '/onboarding/parent/child/:childId/program',
    level: ONBOARDING_LEVEL + 7.75,
  },
  ONBOARDING_PARENT_CHILD_LABOR_EFFECT_READY: {
    id: 'ONBOARDING_PARENT_CHILD_LABOR_EFFECT_READY',
    path: '/onboarding/parent/child/:childId/program/ready',
    level: ONBOARDING_LEVEL + 7.85,
  },
  ONBOARDING_PARENT_CHILD_DEVICE: {
    id: 'ONBOARDING_PARENT_CHILD_DEVICE',
    path: '/onboarding/parent/child/:childId/subjects/device',
    level: ONBOARDING_LEVEL + 8,
  },
  ONBOARDING_PARENT_CHILD_NOTIFICATION_DEVICE: {
    id: 'ONBOARDING_PARENT_CHILD_NOTIFICATION_DEVICE',
    path: '/onboarding/parent/child/:childId/notification/device',
    level: ONBOARDING_LEVEL + 8,
  },
  ONBOARDING_PARENT_CHILD_DEVICE_OTHER: {
    id: 'ONBOARDING_PARENT_CHILD_DEVICE_OTHER',
    path: '/onboarding/parent/child/:childId/device/other',
    level: ONBOARDING_LEVEL + 9,
  },
  ONBOARDING_PARENT_REFERRAL_CODE: {
    id: 'ONBOARDING_PARENT_REFERRAL_CODE',
    path: '/onboarding/parent/child/:childId/referral-code',
    level: ONBOARDING_LEVEL + 10,
  },
  ONBOARDING_PARENT_CHILD_PAYWALL: {
    id: 'ONBOARDING_PARENT_CHILD_PAYWALL',
    path: '/onboarding/parent/child/:childId/paywall',
    level: ONBOARDING_LEVEL + 11,
  },
  ONBOARDING_PARENT_CHILD_DEVICE_SAME: {
    id: 'ONBOARDING_PARENT_CHILD_DEVICE_SAME',
    path: '/onboarding/parent/child/:childId/device/same',
    level: ONBOARDING_LEVEL + 13,
  },
  ONBOARDING_PARENT_CHILD_DEVICE_NOT_AVAILABLE: {
    id: 'ONBOARDING_PARENT_CHILD_DEVICE_NOT_AVAILABLE',
    path: '/onboarding/parent/child/:childId/device/child-not-available',
    level: ONBOARDING_LEVEL + 14,
  },
  ONBOARDING_CHILD_FIRSTNAME: {
    id: 'ONBOARDING_CHILD_FIRSTNAME',
    path: '/onboarding/child/firstname',
    level: ONBOARDING_LEVEL + 1,
  },
  ONBOARDING_CHILD_GENDER: {
    id: 'ONBOARDING_CHILD_GENDER',
    path: '/onboarding/child/gender',
    level: ONBOARDING_LEVEL + 3,
  },
  ONBOARDING_CHILD_SCHOOL_GROUP: {
    id: 'ONBOARDING_CHILD_SCHOOL_GROUP',
    path: '/onboarding/child/school_group',
    level: ONBOARDING_LEVEL + 4,
  },
  ONBOARDING_CHILD_SCHOOL_LEVEL: {
    id: 'ONBOARDING_CHILD_SCHOOL_LEVEL',
    path: '/onboarding/child/school_level',
    level: ONBOARDING_LEVEL + 5,
  },
  ONBOARDING_CHILD_SUBJECTS: {
    id: 'ONBOARDING_CHILD_SUBJECTS',
    path: '/onboarding/child/subjects',
    level: ONBOARDING_LEVEL + 5.5,
  },
  ONBOARDING_CHILD_AVATAR: {
    id: 'ONBOARDING_CHILD_AVATAR',
    path: '/onboarding/child/avatar',
    level: ONBOARDING_CHILD_DEVICE_SAME_LEVEL + 0.5,
  },
  ONBOARDING_CHILD_DEVICE_SAME: {
    id: 'ONBOARDING_CHILD_DEVICE_SAME',
    path: '/onboarding/child/device/same',
    level: ONBOARDING_CHILD_DEVICE_SAME_LEVEL,
  },
  ONBOARDING_CHILD_OBJECTIVE: {
    id: 'ONBOARDING_CHILD_OBJECTIVE',
    path: '/onboarding/child/objective',
    level: ONBOARDING_CHILD_DEVICE_SAME_LEVEL + 1,
  },
  ONBOARDING_CHILD_END: {
    id: 'ONBOARDING_CHILD_END',
    path: '/onboarding/child/end',
    level: ONBOARDING_CHILD_DEVICE_SAME_LEVEL + 2,
  },
  PARENT_HOME: {
    id: 'PARENT_HOME',
    path: '/home/parent',
    level: PARENT_HOME_LEVEL,
  },
  PARENT_HOME_REDIRECT: {
    id: 'PARENT_HOME_REDIRECT',
    path: '*',
    level: PARENT_HOME_LEVEL,
  },
  PARENT_IMPACT: {
    id: 'PARENT_IMPACT',
    path: '/home/parent/impact',
    level: PARENT_HOME_LEVEL,
  },
  PARENT_NOTIFICATIONS: {
    id: 'PARENT_NOTIFICATIONS',
    path: '/home/parent/notifications',
    level: PARENT_HOME_LEVEL,
  },
  PARENT_FAMILY: {
    id: 'PARENT_FAMILY',
    path: '/home/parent/family',
    level: PARENT_HOME_LEVEL,
  },
  PARENT_SETTINGS: {
    id: 'PARENT_SETTINGS',
    path: '/settings',
    level: PARENT_HOME_LEVEL + 1,
  },
  PARENT_REFERRAL: {
    id: 'PARENT_REFERRAL',
    path: '/parent/referral',
    level: PARENT_HOME_LEVEL + 1,
  },
  PARENT_TIMETABLE: {
    id: 'PARENT_TIMETABLE',
    path: '/timetable',
    level: PARENT_HOME_LEVEL + 2,
  },
  PARENT_EDIT_PROFILE: {
    id: 'PARENT_EDIT_PROFILE',
    path: '/parent/edit-profile',
    level: PARENT_HOME_LEVEL + 2,
  },
  PARENT_EDIT_PROFILE_FIRSTNAME: {
    id: 'PARENT_EDIT_PROFILE_FIRSTNAME',
    path: '/parent/edit-profile/firstname',
    level: PARENT_HOME_LEVEL + 3,
  },
  PARENT_EDIT_PROFILE_COUNTRY: {
    id: 'PARENT_EDIT_PROFILE_COUNTRY',
    path: '/parent/edit-profile/country',
    level: PARENT_HOME_LEVEL + 3,
  },
  PARENT_CHILD_FIRSTNAME: {
    id: 'PARENT_CHILD_FIRSTNAME',
    path: '/child/firstname',
    level: PARENT_HOME_LEVEL + 1,
  },
  PARENT_CHILD_GENDER: {
    id: 'PARENT_CHILD_GENDER',
    path: '/child/:childId/gender',
    level: PARENT_HOME_LEVEL + 3,
  },
  PARENT_CHILD_SCHOOL_GROUP: {
    id: 'PARENT_CHILD_SCHOOL_GROUP',
    path: '/child/:childId/school_group',
    level: PARENT_HOME_LEVEL + 4,
  },
  PARENT_CHILD_SCHOOL_LEVEL: {
    id: 'PARENT_CHILD_SCHOOL_LEVEL',
    path: '/child/:childId/school_level',
    level: PARENT_HOME_LEVEL + 5,
  },
  PARENT_CHILD_SUBJECTS: {
    id: 'PARENT_CHILD_SUBJECTS',
    path: '/child/:childId/subjects',
    level: PARENT_HOME_LEVEL + 5.5,
  },
  PARENT_CHILD_EDIT_SUBJECTS: {
    id: 'PARENT_CHILD_EDIT_SUBJECTS',
    path: '/child/:childId/edit-profile/subjects',
    level: PARENT_HOME_LEVEL + 5.6,
  },
  PARENT_CHILD_DEVICE: {
    id: 'PARENT_CHILD_DEVICE',
    path: '/child/:childId/subjects/device',
    level: PARENT_HOME_LEVEL + 6,
  },
  PARENT_CHILD_DEVICE_OTHER: {
    id: 'PARENT_CHILD_DEVICE_OTHER',
    path: '/child/:childId/device/other',
    level: PARENT_HOME_LEVEL + 7,
  },
  PARENT_CHILD_DEVICE_SAME: {
    id: 'PARENT_CHILD_DEVICE_SAME',
    path: '/child/:childId/device/same',
    level: PARENT_HOME_LEVEL + 7,
  },
  PARENT_LESSON: {
    id: 'PARENT_LESSON',
    path: '/parent/lessons/:lessonId',
    level: PARENT_HOME_LEVEL + 8,
  },
  PARENT_LESSON_DIGEST: {
    id: 'PARENT_LESSON_DIGEST',
    path: '/parent/lessons/:lessonId/digest',
    level: PARENT_HOME_LEVEL + 9,
  },
  PARENT_LESSON_CHAPTER_SMARTBITS: {
    id: 'PARENT_LESSON_CHAPTER_SMARTBITS',
    path: '/parent/lessons/:lessonId/chapters/:chapterId/smartbits',
    level: PARENT_HOME_LEVEL + 9,
  },
  PARENT_LESSON_REVISION_SHEET: {
    id: 'PARENT_LESSON_REVISION_SHEET',
    path: '/parent/lessons/:lessonId/revision-sheet',
    level: PARENT_HOME_LEVEL + 9,
  },
  CHILD_HOME: {
    id: 'CHILD_HOME',
    path: '/home',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_HOME_REDIRECT: {
    id: 'CHILD_HOME_REDIRECT',
    path: '*',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_CARDS: {
    id: 'CHILD_CARDS',
    path: '/home/cards',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_FRIENDS: {
    id: 'CHILD_FRIENDS',
    path: '/home/friends',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_PROFILE: {
    id: 'CHILD_PROFILE',
    path: '/home/profile',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_NOTIFICATIONS: {
    id: 'CHILD_NOTIFICATIONS',
    path: '/home/notifications',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_MISSIONS: {
    id: 'CHILD_MISSIONS',
    path: '/missions',
    level: CHILD_HOME_LEVEL,
  },
  CHILD_REFERRAL: {
    id: 'CHILD_REFERRAL',
    path: '/home/referral',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_SETTINGS: {
    id: 'CHILD_SETTINGS',
    path: '/settings',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_EDIT_PROFILE: {
    id: 'CHILD_EDIT_PROFILE',
    path: '/child/edit-profile',
    level: CHILD_HOME_LEVEL + 2,
  },
  CHILD_EDIT_PROFILE_PSEUDO: {
    id: 'CHILD_EDIT_PROFILE_PSEUDO',
    path: '/child/edit-profile/pseudo',
    level: CHILD_HOME_LEVEL + 3,
  },
  CHILD_EDIT_PROFILE_FIRSTNAME: {
    id: 'CHILD_EDIT_PROFILE_FIRSTNAME',
    path: '/child/edit-profile/firstname',
    level: CHILD_HOME_LEVEL + 3,
  },
  CHILD_EDIT_PROFILE_SCHOOL_LEVEL: {
    id: 'CHILD_EDIT_PROFILE_SCHOOL_LEVEL',
    path: '/child/edit-profile/school-level',
    level: CHILD_HOME_LEVEL + 4,
  },
  CHILD_EDIT_PROFILE_SUBJECTS: {
    id: 'CHILD_EDIT_PROFILE_SUBJECTS',
    path: '/child/edit-profile/subjects',
    level: CHILD_HOME_LEVEL + 3,
  },
  CHILD_EDIT_PROFILE_COUNTRY: {
    id: 'CHILD_EDIT_PROFILE_COUNTRY',
    path: '/child/edit-profile/country',
    level: CHILD_HOME_LEVEL + 3,
  },
  CHILD_TIMETABLE: {
    id: 'CHILD_TIMETABLE',
    path: '/timetable',
    level: CHILD_HOME_LEVEL + 5,
  },
  CHILD_ADD_FRIEND: {
    id: 'CHILD_ADD_FRIEND',
    path: '/child/add-friend',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_STAR_ROAD: {
    id: 'CHILD_STAR_ROAD',
    path: '/home/star-road',
    level: LESSON_LEVEL + 5,
  },
  CHILD_STREAK: {
    id: 'CHILD_STREAK',
    path: '/home/streak',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_STREAK_GOAL: {
    id: 'CHILD_STREAK_GOAL',
    path: '/home/streak/goal',
    level: LESSON_LEVEL + 4,
  },
  CHILD_BADGES: {
    id: 'CHILD_BADGES',
    path: '/home/badges',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_BADGES_SHOWCASE: {
    id: 'CHILD_BADGES_SHOWCASE',
    path: '/home/badges/showcase',
    level: CHILD_HOME_LEVEL + 2,
  },
  AVATAR: {
    id: 'AVATAR',
    path: '/avatar',
    level: CHILD_HOME_LEVEL + 1,
  },
  AVATAR_CREATE: {
    id: 'AVATAR_CREATE',
    path: '/avatar/create',
    level: CHILD_HOME_LEVEL + 2,
  },
  AVATAR_GENERATE: {
    id: 'AVATAR_GENERATE',
    path: '/avatar/generate',
    level: CHILD_HOME_LEVEL + 3,
  },
  USER_PROFILE: {
    id: 'USER_PROFILE',
    path: '/user/:userId/profile',
    level: CHILD_HOME_LEVEL + 1,
  },
  LESSONS_SELECT_SUBJECT: {
    id: 'LESSONS_SELECT_SUBJECT',
    path: '/lessons/select-subject',
    level: LESSON_LEVEL,
  },
  LESSONS_BY_SUBJECT: {
    id: 'LESSONS_BY_SUBJECT',
    path: '/subjects/:subject',
    level: LESSON_LEVEL,
  },
  SUBJECT_SELECT_MEDIA: {
    id: 'SUBJECT_SELECT_MEDIA',
    path: '/subjects/:subject/select-media',
    level: LESSON_LEVEL + 1,
  },
  LESSON: {
    id: 'LESSON',
    path: '/lessons/:lessonId',
    level: LESSON_LEVEL + 1,
  },
  LESSON_RENAME: {
    id: 'LESSON_RENAME',
    path: '/lessons/:lessonId/rename',
    level: LESSON_LEVEL + 2,
  },
  LESSON_CHAPTER_SMARTBITS: {
    id: 'LESSON_CHAPTER_SMARTBITS',
    path: '/lessons/:lessonId/chapters/:chapterId/smartbits',
    // Above LESSON_COURSE: the course page opens the sheets, so it must slide forward.
    level: LESSON_LEVEL + 3,
  },
  LESSON_DIGEST: {
    id: 'LESSON_DIGEST',
    path: '/lessons/:lessonId/digest',
    level: LESSON_LEVEL + 3,
  },
  LESSON_REVISION_SHEET: {
    id: 'LESSON_REVISION_SHEET',
    path: '/lessons/:lessonId/revision-sheet',
    level: LESSON_LEVEL + 3,
  },
  LESSON_PRACTICE_STEP: {
    id: 'LESSON_PRACTICE_STEP',
    path: '/lessons/:lessonId/practice/:stepId',
    level: LESSON_LEVEL + 1,
  },
  LESSON_PHOTOS: {
    id: 'LESSON_PHOTOS',
    path: '/lessons/:lessonId/photos',
    level: LESSON_LEVEL + 2,
  },
  LESSON_PHOTOS_EDIT: {
    id: 'LESSON_PHOTOS_EDIT',
    path: '/lessons/:lessonId/photos/edit',
    level: LESSON_LEVEL + 3,
  },
  LESSON_EVALUATION_ASK: {
    id: 'LESSON_EVALUATION_ASK',
    path: '/lessons/:lessonId/evaluation',
    level: LESSON_LEVEL + 2,
  },
  LESSON_EVALUATION_DATE: {
    id: 'LESSON_EVALUATION_DATE',
    path: '/lessons/:lessonId/evaluation/date',
    level: LESSON_LEVEL + 3,
  },
  LESSON_NOTIFICATIONS: {
    id: 'LESSON_NOTIFICATIONS',
    path: '/lessons/:lessonId/notifications',
    level: LESSON_LEVEL + 4,
  },
  LESSON_PROCESSING: {
    id: 'LESSON_PROCESSING',
    path: '/lessons/:lessonId/pieces/processing',
    level: LESSON_LEVEL + 5,
  },
  LESSON_FLASHCARDS: {
    id: 'LESSON_FLASHCARDS',
    path: '/lessons/:lessonId/flashcards',
    level: LESSON_LEVEL + 6,
  },
  LESSON_QUIZ: {
    id: 'LESSON_QUIZ',
    path: '/lessons/:lessonId/quizzes/:quizId',
    level: LESSON_LEVEL + 2,
  },
  LESSON_QUIZ_RESULT: {
    id: 'LESSON_QUIZ_RESULT',
    path: '/lessons/:lessonId/quizzes/:quizId/runs/:runId/result',
    level: LESSON_LEVEL + 3,
  },
  LESSON_COURSE: {
    id: 'LESSON_COURSE',
    path: '/lessons/:lessonId/course',
    level: LESSON_LEVEL + 2,
  },
  EXAM_PHOTO: {
    id: 'EXAM_PHOTO',
    path: '/exams/:examId/pieces/photo',
    level: CHILD_HOME_LEVEL + 1,
  },
  EXAM_LESSON_SELECTION: {
    id: 'EXAM_LESSON_SELECTION',
    path: '/exams/:examId/lesson-selection',
    level: CHILD_HOME_LEVEL + 2,
  },
  EXAM_ANALYSIS: {
    id: 'EXAM_ANALYSIS',
    path: '/exams/:examId/analysis',
    level: CHILD_HOME_LEVEL + 3,
  },
  EXAM_SUMMARY: {
    id: 'EXAM_SUMMARY',
    path: '/exams/:examId/summary',
    level: CHILD_HOME_LEVEL + 4,
  },
  EXAM_ANALYSIS_DETAILS: {
    id: 'EXAM_ANALYSIS_DETAILS',
    path: '/exams/:examId/analysis-details',
    level: CHILD_HOME_LEVEL + 5,
  },
  CHALLENGE: {
    id: 'CHALLENGE',
    path: '/challenges/:challengeId',
    level: PARENT_HOME_LEVEL + 1,
  },
  CHALLENGE_LOGOUT: {
    id: 'CHALLENGE_LOGOUT',
    path: '/challenges/:challengeId',
    level: 1,
  },
  CHALLENGE_LESSON_QUIZ: {
    id: 'CHALLENGE_LESSON_QUIZ',
    path: '/challenges/:challengeId/lessons/:lessonId/quizzes/:quizId/runs/:runId',
    level: PARENT_HOME_LEVEL + 2,
  },
  CHALLENGE_LESSON_QUIZ_RESULT: {
    id: 'CHALLENGE_LESSON_QUIZ_RESULT',
    path: '/challenges/:challengeId/lessons/:lessonId/quizzes/:quizId/runs/:runId/result',
    level: PARENT_HOME_LEVEL + 3,
  },
  CHALLENGE_LESSON_QUIZ_RESULT_ANONYMOUS: {
    id: 'CHALLENGE_LESSON_QUIZ_RESULT_ANONYMOUS',
    path: '/challenges/:challengeId/lessons/:lessonId/quizzes/:quizId/runs/:runId/result',
    level: PARENT_HOME_LEVEL + 3,
  },
  CHILD_SEASONAL_LESSONS: {
    id: 'CHILD_SEASONAL_LESSONS',
    path: '/home/seasonal-lessons/:seasonType',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_SEASONAL_PARKOUR: {
    id: 'CHILD_SEASONAL_PARKOUR',
    path: '/home/seasonal-lessons/:seasonType/lessons/:lessonId/parkour',
    level: CHILD_HOME_LEVEL + 2,
  },
  CHILD_SUMMER_HUB: {
    id: 'CHILD_SUMMER_HUB',
    path: '/home/summer',
    level: CHILD_HOME_LEVEL + 1,
  },
  CHILD_SUMMER_PARKOUR: {
    id: 'CHILD_SUMMER_PARKOUR',
    path: '/home/summer/parkour/:subject',
    level: CHILD_HOME_LEVEL + 2,
  },
  CARD_DETAIL: {
    id: 'CARD_DETAIL',
    path: '/cards/:cardId/:rarity',
    level: CHILD_HOME_LEVEL + 2,
  },
  CARDS_SHOP: {
    id: 'CARDS_SHOP',
    path: '/cards/shop',
    level: CHILD_HOME_LEVEL + 3,
  },
  CARDS_PACK_OPENING: {
    id: 'CARDS_PACK_OPENING',
    path: '/cards/pack-opening/:packId',
    level: CHILD_HOME_LEVEL + 4,
  },
  VSAQ_INTRO: {
    id: 'VSAQ_INTRO',
    path: '/lessons/:lessonId/vsaq/:conversationId/intro',
    level: LESSON_LEVEL + 2,
  },
  VSAQ_CHAT: {
    id: 'VSAQ_CHAT',
    path: '/lessons/:lessonId/vsaq/:conversationId/chat',
    level: LESSON_LEVEL + 2,
  },
  VSAQ_COMPLETION: {
    id: 'VSAQ_COMPLETION',
    path: '/lessons/:lessonId/vsaq/:conversationId/completion',
    level: LESSON_LEVEL + 2,
  },
  VSAQ_RESULT: {
    id: 'VSAQ_RESULT',
    path: '/lessons/:lessonId/vsaq/:conversationId/result',
    level: LESSON_LEVEL + 3,
  },
} as const;

type PathParamNames<P extends string> = P extends `${string}:${infer Rest}`
  ? Rest extends `${infer Name}/${infer Tail}`
    ? Name | PathParamNames<`/${Tail}`>
    : Rest extends `${infer Name}?`
      ? Name
      : Rest
  : never;

type RouteParams<K extends keyof typeof ROUTES> = [
  PathParamNames<(typeof ROUTES)[K]['path']>,
] extends [never]
  ? []
  : [
      params: Record<
        PathParamNames<(typeof ROUTES)[K]['path']>,
        string | number
      >,
    ];

export function generatePath<K extends keyof typeof ROUTES>(
  route: K,
  ...args: RouteParams<K>
): string {
  const params: Record<string, string | number> | undefined = args[0];
  let path: string = ROUTES[route].path;

  if (params) {
    Object.keys(params).forEach(key => {
      path = path.replace(`:${key}`, () => String(params[key]));
    });
  }

  return path;
}

export type RouteId = (typeof ROUTES)[keyof typeof ROUTES]['id'];

export type RouteKey = keyof typeof ROUTES;
